
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from "axios";
import store from "../../store/index";
// import moment from "moment";
// import { ref } from 'vue'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    patid: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: true,
    },
    showLoader:{
      type: Boolean,
      default: false,
    },
    showSideButton:{
      type: Boolean,
      default: true,
    },
    boldfolder: {
      type: String,
      default: "",
    },
    openfolderlist: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      patientid: "",
      listdata: [],
      foldertreelist: {},
      showTreeLoader:{},
      folderswitch:{},
      firstclassname: this.patid,
      folderbyid: "",
      openfolder:"",
      currentselectedfolder:"",
      selectedboldfolder:"",
      previousChild:"",
      showDetails:false,
      showBlock:false,
      arrayfolders: [],
      baseurl: process.env.VUE_APP_Service_URL,
    };
  },
  async beforeMount() {
    await this.setlist();
  },
  watch:{
    "$store.getters.getFolderMoveId": function (val) {
      this.currentselectedfolder = val;                 
    },
    boldfolder(newVal, oldVal) {
      this.currentselectedfolder = newVal;
    },
  },
  async mounted(){
    this.idtoken = store.getters.getIdToken;
    this.selectedboldfolder = this.boldfolder;
  },
  methods: {
    folderFunctionality(type,popupId){
      this.closePopover(popupId)
      const eventMap = {
        edit: 'editFolder',
        add: 'addFolder',
        delete: 'deleteFolder',
        archive: 'archiveFolder',
        clone : 'cloneFolder'
      };
    
      const eventName = eventMap[type];
      if (eventName) {
        this.$emit(eventName);
      }         
    },
    handleInnerFunc(type) {
      const eventMap = {
        edit: 'editFolder',
        add: 'addFolder',
        delete: 'deleteFolder',
        archive: 'archiveFolder',
        clone : 'cloneFolder'
      };
    
      const eventName = eventMap[type];
      if (eventName) {
        this.$emit(eventName);
      }
    },
    async closePopover(id) {
      document.getElementById(id)?document.getElementById(id).hidePopover():null
    },
    async setlist() {
      this.listdata = [...this.list];
    },
    async getFolderChildren(id) {
      this.showTreeLoader[id]=true
      const idtoken = store.getters.getIdToken;      
      if (this.folderswitch[id]) {
        this.folderswitch[id] = !this.folderswitch[id];
        store.dispatch("setFolderMoveId", "");
        this.currentselectedfolder=""
      } else {
        this.folderswitch[id] = true;
        store.dispatch("setFolderMoveId", id);
        this.currentselectedfolder=id;     
        await this.getFolderById(id)        
      }
      this.foldertreelist[id] = [];  
      await axios
        .get(`${this.baseurl}/etmf/folder/getprivilegedchildren?Id=${id}&StudyId=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.showTreeLoader[id]=false
          this.foldertreelist[id] = res.data
        })
        .catch((err) => {
          this.showTreeLoader[id]=false
        });
    },
    async getFolderById(id)
    {
        await axios
          .get(`${this.baseurl}/etmf/folder/getfolderbyid?Id=${id}&StudyId=${store.getters.getStudyIs}`, {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            this.$emit("folderName",res.data.name)
          })
          .catch((err) => {
            console.log(err);
          });
    }
  },
};